"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractParamsProviderMock = void 0;
const bytes_1 = require("@ethersproject/bytes");
const utf8_1 = require("@ethersproject/strings/lib/utf8");
const ContractParamsProvider_1 = require("./ContractParamsProvider");
class ContractParamsProviderMock extends ContractParamsProvider_1.ContractParamsProvider {
    filePath;
    fileReader;
    overriddenFeedIds;
    constructor(dataFeeds, filePath, fileReader) {
        super({ uniqueSignersCount: 0, dataServiceId: "", dataFeeds });
        this.filePath = filePath;
        this.fileReader = fileReader;
    }
    requestPayload(_) {
        return Promise.resolve(this.fileReader(this.filePath).toString());
    }
    getHexlifiedFeedIds() {
        return (this.overriddenFeedIds?.map((feed) => (0, bytes_1.hexlify)((0, utf8_1.toUtf8Bytes)(feed))) ||
            super.getHexlifiedFeedIds());
    }
}
exports.ContractParamsProviderMock = ContractParamsProviderMock;
//# sourceMappingURL=ContractParamsProviderMock.js.map